import { Image } from 'lego-on-react';
import * as React from 'react';
import { useCallback } from 'react';

import { Bem } from '../../service/Bem/Bem';
import { PresetsProps } from '../Presets/typings';

import './VideoPresets.css';

const BLOCK = 'video-presets';

type VideoPresetsProps = Pick<PresetsProps, 'dataProvider' | 'selectPreset'>;

export class VideoPresets extends React.PureComponent<VideoPresetsProps> {
    static PresetItem = React.memo(
        (props: { thumbnail: string; alt: string; id: string; click: (id: string) => void }) => {
            const onClick = useCallback(() => props.click(props.id), [props.id]);
            return (
                <span onClick={onClick}>
                    <Image url={props.thumbnail} alt={props.alt} cls={Bem.cls(BLOCK, 'image')} />
                </span>
            );
        }
    );

    render(): React.ReactNode {
        const { dataProvider, selectPreset } = this.props;

        return (
            <div className={BLOCK}>
                {dataProvider.map(item => (
                    <VideoPresets.PresetItem
                        key={item.id}
                        click={selectPreset}
                        thumbnail={item.thumbnail}
                        alt={item.alt}
                        id={item.id}
                    />
                ))}
            </div>
        );
    }
}
